import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default function DefaultCheckbox({label, disabled, name, value, setValue, labelSx, cbSx}) {
  return (
    <FormControlLabel
      sx={{...labelSx, height: '30px'}}
      className={'width-fit-content'}
      label={label}
      disabled={disabled}
      control={
        <Checkbox 
          sx={cbSx || {}}
          name={name}
          size={'small'}
          checked={typeof value === 'boolean' ? value : false}
          onChange={(e, checked) => setValue(checked)}
        />
      } 
    />
  )
}
